import React, { Component } from 'react'
import { Grid, withStyles } from "@material-ui/core"
import FontW7 from "../Font/FontW7";
import FontW5 from "../Font/FontW5";

const style = theme => ({
    fixHeight: {
        height: 540,
        marginRight: -45,
        backgroundPosition: 'right',
        [theme.breakpoints.down('sm')]: {
            height: 300,
            marginTop: '0 !important',
            margin: '5px 0',
            backgroundPosition: 'center',
        },
        backgroundSize: 'auto 100%',
        backgroundRepeat: 'no-repeat',
        // marginTop: -160,
    },
    fixContent: {
        padding: '0px 15px',
        ['@media (min-width:960px)']: {
            maxWidth: 440
        },
        ['@media (min-width:992px)']: {
            maxWidth: 470,
        },
        ['@media (min-width:1200px)']: {
            maxWidth: 585,
        },
        marginRight: 'auto',
       // marginLeft: -30,
        [theme.breakpoints.down('sm')]: {
            margin: '0 auto',
        }
    },
    fix150: {
        margin: 'auto 0px',
        textAlign: 'justify',
        textJustify: 'auto',
        [theme.breakpoints.down('sm')]: {
            marginTop: 10,
            marginBottom: 10,
            textAlign: 'center',
        },
    },
    title: {
        // whiteSpace: "nowrap",
        fontSize: "22pt",
        lineHeight: 1.5,
        [theme.breakpoints.down('sm')]: {
            fontSize: "18pt",
        },
    }
})

class AboutLeft extends Component {
    render() {
        const { img, title, content, classes, marginOnTop, setMargin, paddingTop} = this.props
        return (
            <div
                id="section-1"
                className={"clearfix about-style-2 "+ paddingTop}
                style={{
                    backgroundColor: '#fff',
                }}
            >
                {/*<div*/}
                    {/*container*/}
                    {/*className="container"*/}
                    {/*style={{padding: 0}}*/}
                {/*>*/}
                   <Grid container>
                    <Grid item md={6} xs={12} style={{ display: 'flex' }}>
                        <div
                            className={"wow fadeInLeft " + classes.fixHeight + ' ' + setMargin}
                            style={{
                                flex: 1,
                                backgroundImage: `url(${img})`,
                                marginTop: marginOnTop ? marginOnTop : 0,
                            }}
                            data-wow-delay=".3s"
                        />
                    </Grid>
                    <Grid container item md={6} xs={12} className={classes.fixContent}>
                        <Grid item xs={12} className={"text-body wow fadeInRight " + classes.fix150}
                              data-wow-delay=".3s">
                            <p>
                                <FontW7 className={classes.title}>
                                    {title}
                                </FontW7>
                                <br style={{lineHeight: 4}}/>
                                <FontW5 className="font-16px">
                                    {content}
                                </FontW5>
                            </p>
                        </Grid>
                    </Grid>
                   </Grid>
                {/*</div>*/}
            </div>
        )
    }
}

export default withStyles(style)(AboutLeft)
